<template>
  <div id="set_permissions">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"
        ></i>权限管理
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px">刷新</div>
        </div>
      </div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div
          style="float: left;line-height: 46px;padding-left: 10px; margin-left:10px"
        >当前部门:{{name}}</div>
      </div>
      <!--  :default-expanded-keys="expandId"
            @check="checkChange"
      -->
      <div class="permissins_box">
        <div class="tree">
          <!-- :default-expanded-keys="change_check" -->
          <el-tree
            :props="defaultProps"
            :data="permissionsList"
            show-checkbox
            node-key="id"
            :default-checked-keys="change_check"
            @check-change="checkChange"
            @check="current_change"
            ref="tree"
          >
            <!--   -->
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span v-if="data.only_fun == 0" style="margin-left:20px">
                <el-button
                  type="text"
                  size="mini"
                  :class="data.add == '0' ? 'change_btn' : ''"
                  @click="add(node,data)"
                >增</el-button>
                <el-button
                  type="text"
                  size="mini"
                  :class="data.del == '0' ? 'change_btn' : ''"
                  @click="del(node,data)"
                >删</el-button>
                <el-button
                  type="text"
                  size="mini"
                  :class="data.edit == '0' ? 'change_btn' : ''"
                  @click="edit(node,data)"
                >改</el-button>
                <el-button
                  type="text"
                  size="mini"
                  :class="data.info == '0' ? 'change_btn' : ''"
                  @click="info(node,data)"
                >查</el-button>
              </span>
            </span>
          </el-tree>
        </div>
        <div class="button_box">
          <el-button size="small" @click="submitRoot">提交权限</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      change_add: null, //增删改查 单独值
      submit_checkedKeys: [],
      submit_checkedNodes: [],
      change_check: [], //默认选中
      defaultProps: {
        children: "children",
        label: "name"
      },
      serve: this.$store.state.serve,
      username: "",
      token: "",
      permissionsList: [],
      name: "",
      id: this.$route.params.id,
      expandId: [],
      checkId: [],
      submitPermission: [],
      json_arr: []
    };
  },
  created() {
    this.$store.state.leftTitle = "部门管理";
    this.$store.state.topActiveId = 6;
    this.username = this.$cookies.get("username");
    this.token = this.$cookies.get("token");
    this.get_permissions_list();
    this.get_oneself_permissions();
  },
  methods: {
    current_change(node, data) {
      this.submit_checkedKeys = data.checkedKeys;
      this.checkedNodes = data.checkedNodes;
      // console.log(data.checkedKeys);
      // console.log(data.checkedNodes);
    },

    submitRoot() {
      
      var arr = [];
      const fromData = new FormData();
      fromData.append("username", this.username);
      fromData.append("token", this.token);
      fromData.append("group_id", this.id);
      fromData.append("auth_id", JSON.stringify(this.permissionsList));
      this.axios.post(this.serve + "/admin/set_auth", fromData).then(res => {
        if (res.data.status == "success") {
          this.$message({
            type: "success",
            message: res.data.msg
          });
          // this.get_permissions_list()
        }else if(res.data.code == '403'){
          this.$message.error(res.data.msg); 
        } else if (res.data.status == "error") {
          this.$message.error(res.data.msg);
        }
      });
    },
    checkChange(data, keys, indeterminate) {
     
      if (data.children && keys && !data.i) {
        //点击第一级
        var child = data.children;
        data.i = 1;
        for (var i in child) {
          child[i].add = "1";
          child[i].del = "1";
          child[i].edit = "1";
          child[i].info = "1";
        }
      } else if (data.children && keys == false && !data.i) {
        var child = data.children;
        for (var i in child) {
          child[i].add = "0";
          child[i].del = "0";
          child[i].edit = "0";
          child[i].info = "0";
        }
      }

      if (data.f_id && keys) {
        //点击第二级
        data.add = "1";
        data.del = "1";
        data.edit = "1";
        data.info = "1";
      } else if (data.f_id && keys == false) {
        data.add = "0";
        data.del = "0";
        data.edit = "0";
        data.info = "0";
      }

      return;
      if (!data.f_id && !data.children) {
        // var new_data = data.
        // console.log(keys)
        if (data.f_id) {
          if (
            data.add == null ||
            (data.add == null && keys) ||
            data.add == "0"
          ) {
            data.add = "1";
            data.del = "1";
            data.edit = "1";
            data.info = "1";
          } else if (keys == false) {
            data.add = "0";
            data.del = "0";
            data.edit = "0";
            data.info = "0";
          }
        }
      }
    },
    get_permissions_list() {
      this.axios
        .get(this.serve + "/admin/list_auth", {
          params: {
            username: this.username,
            token: this.token,
            group_id: this.id
          }
        })
        .then(res => {
          console.log(res);
          if (res.data.status == "success") {
            const json = res.data.data;
            this.permissionsList = json;
            for (var i in json) {
              let farst = json[i].children;
              for (var k in farst) {
                if (
                  farst[k].add === "1" &&
                  farst[k].del === "1" &&
                  farst[k].edit === "1" &&
                  farst[k].info === "1"
                ) {
                  this.change_check.push(parseInt(farst[k].id));
                }
              }
            }
          }
        });
    },
    add(node, data) {
      const arr = this.permissionsList;
      for (var i in arr) {
        if (arr[i] == data.id) {
          // console.log('选择的第一级')
        }
        const arr_ch = arr[i].children;
        for (var k in arr_ch) {
          if (arr_ch[k].id == data.id) {
            // console.log('选择的第二级')
            if (arr_ch[k].add == "1") {
              arr_ch[k].add = "0";
            } else if (arr_ch[k].add == null || arr_ch[k].add == "0") {
              arr_ch[k].add = "1";
            }
          }
        }
      }
    },
    del(node, data) {
      const arr = this.permissionsList;
      for (var i in arr) {
        if (arr[i] == data.id) {
          // console.log('选择的第一级')
        }
        const arr_ch = arr[i].children;
        for (var k in arr_ch) {
          if (arr_ch[k].id == data.id) {
            // console.log('选择的第二级')
            if (arr_ch[k].del == "1") {
              arr_ch[k].del = "0";
            } else if (arr_ch[k].del == null || arr_ch[k].del == "0") {
              arr_ch[k].del = "1";
            }
          }
        }
      }
    },
    edit(node, data) {
      const arr = this.permissionsList;
      for (var i in arr) {
        if (arr[i] == data.id) {
          // console.log('选择的第一级')
        }
        const arr_ch = arr[i].children;
        for (var k in arr_ch) {
          if (arr_ch[k].id == data.id) {
            // console.log('选择的第二级')
            if (arr_ch[k].edit == "1") {
              arr_ch[k].edit = "0";
            } else if (arr_ch[k].edit == null || arr_ch[k].edit == "0") {
              arr_ch[k].edit = "1";
            }
          }
        }
      }
    },
    info(node, data) {
      const arr = this.permissionsList;
      for (var i in arr) {
        if (arr[i] == data.id) {
          // console.log('选择的第一级')
        }
        const arr_ch = arr[i].children;
        for (var k in arr_ch) {
          if (arr_ch[k].id == data.id) {
            // console.log('选择的第二级')
            if (arr_ch[k].info == "1") {
              arr_ch[k].info = "0";
            } else if (arr_ch[k].info == null || arr_ch[k].info == "0") {
              arr_ch[k].info = "1";
            }
          }
        }
      }
    },
    get_oneself_permissions() {
      var formData = {
        username: this.username,
        token: this.token,
        id: this.id
      };
      this.axios
        .get(this.serve + "/admin/get_admin_group_info", {
          params: formData
        })
        .then(res => {
          this.name = res.data.data.name;
        });
    }
  }
};
</script>

<style lang="scss">
#set_permissions {
  background: #f5f5f5;
  color: #333;
  min-height: 1000px;
  .change_btn {
    color: #606266;
  }
  .custom-tree-node {
    display: flex;
    align-items: center;
    font-size: 14px;
    padding-right: 8px;
  }
  .el-tree-node__label {
    margin-left: 10px;
  }
  .permissins_box {
    background-color: #fff;
    /* padding: 20px; */
    /* min-height: 600px; */
  }
  .button_box {
    padding: 20px;
  }
  .button {
    margin: 0 auto;
  }

  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
  }

  .form-title {
    background-color: #eee;
    border: 1px solid #ddd;
    line-height: 46px;
    height: 46px;
  }

  .button {
    border-radius: 5px;
  }
  .rutun {
    width: 78px;
    height: 28px;
    background: #fff;
    border: 1px solid rgba(221, 221, 221, 1);
    text-align: center;
    margin-top: 9px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
}
</style>